import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 pb-1" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-5 col-sm-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "input-error"
}
const _hoisted_8 = { class: "col-lg-5 col-sm-6 mt-4" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-3 col-sm-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4"
}
const _hoisted_17 = { class: "card-body p-4" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-8 col-sm-6" }
const _hoisted_20 = { class: "form-group mb-4" }
const _hoisted_21 = { class: "form-check form-switch" }
const _hoisted_22 = { class: "input-error" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-8 col-sm-6" }
const _hoisted_25 = { class: "form-group mb-4" }
const _hoisted_26 = { class: "input-error" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-2" }
const _hoisted_29 = { class: "form-group mb-4" }
const _hoisted_30 = { value: null }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "input-error" }
const _hoisted_33 = { class: "col-lg-12" }
const _hoisted_34 = { class: "form-group mb-2" }
const _hoisted_35 = { class: "input-error" }
const _hoisted_36 = { class: "form-group mb-4" }
const _hoisted_37 = { class: "input-error" }
const _hoisted_38 = { class: "form-group mb-4" }
const _hoisted_39 = { class: "input-error" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = ["src"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "col-lg-12 mt-4" }
const _hoisted_46 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_50 = {
  key: 2,
  role: "status"
}
const _hoisted_51 = {
  key: 1,
  class: "card bg-white border-0 rounded-3 mb-4"
}
const _hoisted_52 = { class: "card-body p-4" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-lg-4 col-sm-6" }
const _hoisted_55 = { class: "form-group mb-4" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "input-error" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-lg-10 col-sm-6" }
const _hoisted_60 = { class: "form-group mb-4" }
const _hoisted_61 = { class: "input-error" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-10 col-sm-6" }
const _hoisted_64 = { class: "form-group mb-4" }
const _hoisted_65 = { class: "input-error" }
const _hoisted_66 = {
  key: 0,
  class: "row"
}
const _hoisted_67 = { class: "col-lg-10 col-sm-6" }
const _hoisted_68 = { class: "form-group mb-4" }
const _hoisted_69 = { class: "input-error" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-lg-10 col-sm-6" }
const _hoisted_72 = { class: "form-group mb-4" }
const _hoisted_73 = { class: "input-error" }
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-lg-2 col-sm-6" }
const _hoisted_76 = { class: "form-group mb-4" }
const _hoisted_77 = { class: "input-error" }
const _hoisted_78 = { class: "col-lg-2 col-sm-6" }
const _hoisted_79 = { class: "form-group mb-4" }
const _hoisted_80 = { class: "input-error" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-lg-2 col-sm-6" }
const _hoisted_83 = { class: "form-group mb-4" }
const _hoisted_84 = { class: "input-error" }
const _hoisted_85 = {
  key: 0,
  class: "col-lg-2 col-sm-6"
}
const _hoisted_86 = { class: "form-group mb-4" }
const _hoisted_87 = { value: null }
const _hoisted_88 = ["value"]
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-lg-2" }
const _hoisted_91 = { class: "form-group mb-4" }
const _hoisted_92 = { value: null }
const _hoisted_93 = ["value"]
const _hoisted_94 = { class: "input-error" }
const _hoisted_95 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_96 = { class: "form-group mb-4" }
const _hoisted_97 = { class: "input-error" }
const _hoisted_98 = { class: "form-group mb-4" }
const _hoisted_99 = { class: "input-error" }
const _hoisted_100 = { class: "form-group mb-4" }
const _hoisted_101 = { class: "input-error" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = ["src"]
const _hoisted_104 = ["src"]
const _hoisted_105 = ["src"]
const _hoisted_106 = ["src"]
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-lg-4 col-sm-6" }
const _hoisted_109 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_110 = ["value"]
const _hoisted_111 = { class: "input-error" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = { class: "col-lg-8" }
const _hoisted_114 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4 mt-4"
}
const _hoisted_115 = { class: "row" }
const _hoisted_116 = { class: "col-lg-10 col-sm-6" }
const _hoisted_117 = { class: "form-group mb-4" }
const _hoisted_118 = { class: "input-group h-45" }
const _hoisted_119 = { class: "input-error" }
const _hoisted_120 = { class: "input-error" }
const _hoisted_121 = ["onDragstart", "onDrop"]
const _hoisted_122 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_123 = { class: "d-flex align-items-center form-check m-0" }
const _hoisted_124 = ["onUpdate:modelValue"]
const _hoisted_125 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_126 = ["onUpdate:modelValue"]
const _hoisted_127 = ["onClick"]
const _hoisted_128 = ["onClick"]
const _hoisted_129 = {
  class: /*@__PURE__*/_normalizeClass(['fs-13 fw-semibold'])
}
const _hoisted_130 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_131 = ["onClick"]
const _hoisted_132 = ["title"]
const _hoisted_133 = ["onClick", "title"]
const _hoisted_134 = ["onClick"]
const _hoisted_135 = ["onClick"]
const _hoisted_136 = { class: "row" }
const _hoisted_137 = { class: "col-lg-12 mt-4" }
const _hoisted_138 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_139 = ["disabled"]
const _hoisted_140 = { key: 0 }
const _hoisted_141 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_142 = {
  key: 2,
  role: "status"
}
const _hoisted_143 = {
  id: "mdlFileUpload",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlFileUploadLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_144 = { class: "modal-dialog modal-md" }
const _hoisted_145 = { class: "modal-content" }
const _hoisted_146 = { class: "modal-body" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = { class: "col-lg-8" }
const _hoisted_149 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_150 = { value: null }
const _hoisted_151 = ["value"]
const _hoisted_152 = ["value"]
const _hoisted_153 = { class: "input-error" }
const _hoisted_154 = { class: "row" }
const _hoisted_155 = { key: 1 }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = ["src"]
const _hoisted_158 = ["src"]
const _hoisted_159 = { class: "col-lg-5" }
const _hoisted_160 = { class: "modal-footer" }
const _hoisted_161 = {
  id: "mdlFileUploadQuestion",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlFileUploadLabelQuestion",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_162 = { class: "modal-dialog modal-md" }
const _hoisted_163 = { class: "modal-content" }
const _hoisted_164 = { class: "modal-header" }
const _hoisted_165 = {
  key: 0,
  class: "modal-title fs-5",
  id: "mdlFileUploadLabelQuestion"
}
const _hoisted_166 = { class: "modal-body" }
const _hoisted_167 = { class: "row" }
const _hoisted_168 = { class: "col-lg-8" }
const _hoisted_169 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_170 = { value: 0 }
const _hoisted_171 = ["value"]
const _hoisted_172 = { class: "input-error" }
const _hoisted_173 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_FilePond = _resolveComponent("FilePond")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoadingCreate }, null, 8 /* PROPS */, ["visible"]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath
    })),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[58] || (_cache[58] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre de la Jugada", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el Nombre de la Jugada",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.playName) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('errors.playName'))),
                disabled: _ctx.idPlay != ''
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                [_vModelText, _ctx.playName]
              ]),
              (_ctx.errors.playName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errors.playName), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createPlayName())),
              class: "btn btn-primary py-1 px-3 me-3 mt-2 fw-medium fs-14 rounded-3 hover-bg"
            }, _cache[59] || (_cache[59] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("span", null, "Crear jugada")
              ], -1 /* HOISTED */)
            ]), 512 /* NEED_PATCH */), [
              [_vShow, _ctx.idPlay == '']
            ]),
            _createVNode(_component_RouterLink, {
              to: 
              _ctx.route.path.split('/')[1] != 'repository'
                ? `/play/config/${_ctx.idPlay}`
                : '/repository'
            
            }, {
              default: _withCtx(() => _cache[60] || (_cache[60] = [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary py-1 px-3 mt-2 fw-medium fs-14 rounded-3 hover-bg"
                }, [
                  _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                    _createElementVNode("span", null, "Regresar")
                  ])
                ], -1 /* HOISTED */)
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[62] || (_cache[62] = _createElementVNode("label", { class: "label text-secondary" }, "Acción", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-control h-45",
                "aria-label": "Default select example",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.playTypeId) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetValues())),
                disabled: _ctx.route.params.id != undefined && _ctx.route.params.id > 0
              }, [
                _cache[61] || (_cache[61] = _createElementVNode("option", { value: 0 }, "-- Seleccionar --", -1 /* HOISTED */)),
                _createElementVNode("option", {
                  value: _ctx.PLAY_TYPES.COMBINE
                }, "Contenido", 8 /* PROPS */, _hoisted_14),
                _createElementVNode("option", {
                  value: _ctx.PLAY_TYPES.QUIZ
                }, "Quiz", 8 /* PROPS */, _hoisted_15)
              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_13), [
                [_vModelSelect, _ctx.playTypeId]
              ])
            ])
          ])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.idPlay != '']
      ])
    ]),
    (_ctx.playTypeId == _ctx.PLAY_TYPES.COMBINE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("form", {
              onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm_Content && _ctx.validateForm_Content(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[64] || (_cache[64] = _createElementVNode("label", { class: "label text-secondary" }, "¿Subir contenido?", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "flexSwitchCheckDefault",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.playType.flagUploadContent) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.playType.flagUploadContent]
                      ]),
                      _cache[63] || (_cache[63] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "flexSwitchCheckDefault"
                      }, null, -1 /* HOISTED */))
                    ]),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.errors.flagUploadContent), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[65] || (_cache[65] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
                    _createVNode(_component_TextEditor, {
                      class: "text-editor",
                      modelValue: _ctx.playType.description,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.playType.description) = $event)),
                      placeholder: 'Ingrese el contenido'
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.errors.description), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[66] || (_cache[66] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo de Multimedia", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.playType.multimediaTypeId) = $event)),
                      onChange: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (
                  _ctx.setMultimediaTypeContent(_ctx.playType.multimediaTypeId)
                ), ["prevent"])),
                      class: "form-select form-control h-45",
                      "aria-label": "Default select example"
                    }, [
                      _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multimediaOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.value,
                          value: option.value
                        }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_31))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, _ctx.playType.multimediaTypeId]
                    ]),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.errors.multimediaTypeId), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("div", _hoisted_34, [
                    _cache[67] || (_cache[67] = _createElementVNode("label", { class: "label text-secondary" }, "Multimedia", -1 /* HOISTED */)),
                    (!_ctx.playType.urlMultimedia)
                      ? (_openBlock(), _createBlock(_component_FilePond, {
                          key: 0,
                          style: {"margin-bottom":"-12px important!"},
                          ref: "filePondRef",
                          name: "fileMultimedia",
                          maxFileSize: 
                  _ctx.playType.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.VIDEO
                    ? '20MB'
                    : '2MB'
                ,
                          "accepted-file-types": _ctx.supportedFormats,
                          "allow-multiple": "false",
                          "max-files": 1,
                          "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                          labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                          labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                          labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                          fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(
                  ', '
                )}`,
                          credits: "",
                          onUpdatefiles: _ctx.handleUpdateFiles,
                          onRemovefile: _ctx.handleRemoveFile,
                          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('fileMultimedia')))
                        }, null, 8 /* PROPS */, ["maxFileSize", "accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles", "onRemovefile"]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.errors.fileMultimedia), 1 /* TEXT */)
                  ], 512 /* NEED_PATCH */), [
                    [_vShow, 
                _ctx.playType.multimediaTypeId != null &&
                _ctx.playType.multimediaTypeId != _ctx.MULTIMEDIA_TYPES.LINK
              ]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[68] || (_cache[68] = _createElementVNode("label", { class: "label text-secondary" }, "Link", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "Ingrese el link",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.playType.link) = $event)),
                      onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('link')))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.playType.link]
                    ]),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.errors.link), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[69] || (_cache[69] = _createElementVNode("label", { class: "label text-secondary" }, "Texto del Link", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "Ingrese el texto del link",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.playType.steps) = $event)),
                      onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearError('steps')))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.playType.steps]
                    ]),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.errors.steps), 1 /* TEXT */)
                  ])
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.playType.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.LINK]
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    (
                  _ctx.playType.urlMultimedia &&
                  _ctx.playType.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.IMAGE
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("img", {
                            src: _ctx.playType.urlMultimedia,
                            alt: "Multimedia",
                            class: "img-fluid mb-2 d-block",
                            style: {"width":"25%"}
                          }, null, 8 /* PROPS */, _hoisted_41)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.videoBlobUrl)
                      ? (_openBlock(), _createElementBlock("video", {
                          key: 1,
                          src: _ctx.videoBlobUrl,
                          controls: "",
                          width: "250"
                        }, null, 8 /* PROPS */, _hoisted_42))
                      : _createCommentVNode("v-if", true),
                    (_ctx.audioUrl)
                      ? (_openBlock(), _createElementBlock("audio", {
                          key: 2,
                          src: _ctx.audioUrl,
                          controls: "",
                          style: {"margin-top":"1rem"}
                        }, null, 8 /* PROPS */, _hoisted_43))
                      : _createCommentVNode("v-if", true),
                    (_ctx.pdfUrl)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 3,
                          src: _ctx.pdfUrl,
                          width: "100%",
                          height: "700px"
                        }, null, 8 /* PROPS */, _hoisted_44))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeMultimediaFile && _ctx.removeMultimediaFile(...args)), ["prevent"])),
                    class: "btn btn-danger"
                  }, " Eliminar multimedia ")
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_RouterLink, {
                    to: 
                _ctx.playType.playId == 0
                  ? '/repository'
                  : `/play/config/${_ctx.playType.playId}`
              
                  }, {
                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                      }, " Cancelar ", -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]),
                  _createElementVNode("button", {
                    class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                    type: "submit",
                    disabled: _ctx.isLoading
                  }, [
                    (!_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.playType.id == 0 ? "Crear Acción" : "Actualizar Acción"), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Procesando..."))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_47)
                ])
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.playTypeId == _ctx.PLAY_TYPES.QUIZ)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("form", {
              onSubmit: _cache[51] || (_cache[51] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm_Question && _ctx.validateForm_Question(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _cache[72] || (_cache[72] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo de Pregunta", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-control h-45",
                      "aria-label": "Default select example",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.question.questionTypeId) = $event)),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearError('questionTypeId')))
                    }, [
                      _cache[71] || (_cache[71] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsQuestionTypes, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          key: i
                        }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_56))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, _ctx.question.questionTypeId]
                    ]),
                    _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.errors.questionTypeId), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _cache[73] || (_cache[73] = _createElementVNode("label", { class: "label text-secondary" }, "Enunciado de la Pregunta", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "Ingresar el enunciado de la pregunta",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.question.sentence) = $event)),
                      onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearError('sentence')))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.question.sentence]
                    ]),
                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.errors.sentence), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _cache[74] || (_cache[74] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
                    _createVNode(_component_TextEditor, {
                      onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.clearError('description'))),
                      class: "text-editor",
                      modelValue: _ctx.question.description,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.question.description) = $event)),
                      placeholder: 'Ingrese el contenido'
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.errors.description), 1 /* TEXT */)
                  ])
                ])
              ]),
              (_ctx.question.questionTypeId == _ctx.QUESTION_TYPE.SEMIOPEN)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _cache[75] || (_cache[75] = _createElementVNode("label", { class: "label text-secondary" }, "Respuesta", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control h-45",
                          placeholder: "Ingresar la respuesta correcta",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.question.answer) = $event)),
                          onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.clearError('answer')))
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                          [_vModelText, _ctx.question.answer]
                        ]),
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.errors.answer), 1 /* TEXT */)
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _cache[76] || (_cache[76] = _createElementVNode("label", { class: "label text-secondary" }, "Pista", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "Ingresar una pista",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.question.hint) = $event)),
                      onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.clearError('hint')))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.question.hint]
                    ]),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.errors.hint), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _cache[77] || (_cache[77] = _createElementVNode("label", { class: "label text-secondary" }, "Reintentos", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.question.retries) = $event)),
                      onInput: _cache[27] || (_cache[27] = ($event: any) => {
                  _ctx.handleQuestionInput($event, 'retries');
                  _ctx.clearError('retries');
                }),
                      maxlength: "2"
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.question.retries]
                    ]),
                    _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.errors.retries), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _cache[78] || (_cache[78] = _createElementVNode("label", { class: "label text-secondary" }, "Puntos bonus", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.question.bonusPoints) = $event)),
                      onInput: _cache[29] || (_cache[29] = ($event: any) => {
                  _ctx.handleQuestionInput($event, 'bonusPoints');
                  _ctx.clearError('bonusPoints');
                }),
                      maxlength: "3"
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelText, _ctx.question.bonusPoints]
                    ]),
                    _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.errors.bonusPoints), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _cache[79] || (_cache[79] = _createElementVNode("label", { class: "label text-secondary" }, "Timer(Segundos)", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-45",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.question.timer) = $event)),
                      maxlength: "18"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.question.timer]
                    ]),
                    _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.errors.timer), 1 /* TEXT */)
                  ])
                ]),
                (_ctx.question.timer != null && _ctx.question.timer > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _cache[80] || (_cache[80] = _createElementVNode("label", { class: "label text-secondary" }, "Siguiente acción", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.question.quizContentId) = $event)),
                          onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.handleQuizContentChange && _ctx.handleQuizContentChange(...args))),
                          class: "form-select form-control h-45",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", _hoisted_87, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsConfigNext, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: i
                            }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_88))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                          [_vModelSelect, _ctx.question.quizContentId]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _cache[81] || (_cache[81] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo de Multimedia", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.question.multimediaTypeId) = $event)),
                      onChange: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (
                  _ctx.setMultimediaTypeContent(_ctx.question.multimediaTypeId)
                ), ["prevent"])),
                      class: "form-select form-control h-45",
                      "aria-label": "Default select example"
                    }, [
                      _createElementVNode("option", _hoisted_92, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multimediaOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.value,
                          value: option.value
                        }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_93))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, _ctx.question.multimediaTypeId]
                    ]),
                    _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.errors.multimediaTypeId), 1 /* TEXT */)
                  ])
                ]),
                (_ctx.question.multimediaTypeId != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _cache[82] || (_cache[82] = _createElementVNode("label", { class: "label text-secondary" }, "Multimedia", -1 /* HOISTED */)),
                        (!_ctx.question.urlMultimedia)
                          ? _withDirectives((_openBlock(), _createBlock(_component_FilePond, {
                              key: 0,
                              ref: "filePondRefQuestion",
                              style: {"margin-bottom":"-12px important!"},
                              name: "fileMultimedia",
                              maxFileSize: 
                  _ctx.question.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.VIDEO
                    ? '20MB'
                    : '2MB'
                ,
                              "accepted-file-types": _ctx.supportedFormats,
                              "allow-multiple": "false",
                              "max-files": 1,
                              "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                              labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                              labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                              labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                              fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(
                  ', '
                )}`,
                              credits: "",
                              onUpdatefiles: _ctx.handleUpdateFiles,
                              onRemovefile: _ctx.handleRemoveFile,
                              onInput: _cache[35] || (_cache[35] = ($event: any) => (_ctx.clearError('fileMultimedia')))
                            }, null, 8 /* PROPS */, ["maxFileSize", "accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles", "onRemovefile"])), [
                              [_vShow, _ctx.question.multimediaTypeId != _ctx.MULTIMEDIA_TYPES.LINK]
                            ])
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.errors.fileMultimedia), 1 /* TEXT */)
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_98, [
                          _cache[83] || (_cache[83] = _createElementVNode("label", { class: "label text-secondary" }, "Link", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control h-45",
                            placeholder: "Ingrese el link",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.question.link) = $event)),
                            onInput: _cache[37] || (_cache[37] = ($event: any) => (_ctx.clearError('link')))
                          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, _ctx.question.link]
                          ]),
                          _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.errors.link), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_100, [
                          _cache[84] || (_cache[84] = _createElementVNode("label", { class: "label text-secondary" }, "Texto del Link", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control h-45",
                            placeholder: "Ingrese el texto del link",
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.question.steps) = $event)),
                            onInput: _cache[39] || (_cache[39] = ($event: any) => (_ctx.clearError('steps')))
                          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, _ctx.question.steps]
                          ]),
                          _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.errors.steps), 1 /* TEXT */)
                        ])
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.question.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.LINK]
                      ]),
                      _createElementVNode("div", null, [
                        (
                  _ctx.question.urlMultimedia &&
                  _ctx.question.multimediaTypeId == _ctx.MULTIMEDIA_TYPES.IMAGE
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              _createElementVNode("img", {
                                src: _ctx.question.urlMultimedia,
                                alt: "Multimedia",
                                class: "img-fluid mb-2 d-block"
                              }, null, 8 /* PROPS */, _hoisted_103)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.videoBlobUrlQuestion)
                          ? (_openBlock(), _createElementBlock("video", {
                              key: 1,
                              src: _ctx.videoBlobUrlQuestion,
                              controls: "",
                              width: "270"
                            }, null, 8 /* PROPS */, _hoisted_104))
                          : _createCommentVNode("v-if", true),
                        (_ctx.audioUrlQuestion)
                          ? (_openBlock(), _createElementBlock("audio", {
                              key: 2,
                              src: _ctx.audioUrlQuestion,
                              controls: "",
                              style: {"margin-top":"1rem"}
                            }, null, 8 /* PROPS */, _hoisted_105))
                          : _createCommentVNode("v-if", true),
                        (_ctx.pdfUrlQuestion)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 3,
                              src: _ctx.pdfUrlQuestion,
                              width: "100%",
                              height: "700px"
                            }, null, 8 /* PROPS */, _hoisted_106))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[40] || (_cache[40] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeMultimediaFile && _ctx.removeMultimediaFile(...args)), ["prevent"])),
                        class: "btn btn-danger"
                      }, " Eliminar multimedia ")
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  (_ctx.question.questionTypeId == _ctx.QUESTION_TYPE.CLOSED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                        _cache[86] || (_cache[86] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo de Respuesta", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select form-control h-45",
                          "aria-label": "Default select example",
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.question.answerType) = $event)),
                          onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.clearError('answerType')))
                        }, [
                          _cache[85] || (_cache[85] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsAnswerTypes, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: i
                            }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_110))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                          [_vModelSelect, _ctx.question.answerType]
                        ]),
                        _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.errors.answerType), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  (_ctx.question.questionTypeId == _ctx.QUESTION_TYPE.CLOSED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        _cache[95] || (_cache[95] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Respuestas", -1 /* HOISTED */)),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("div", _hoisted_118, [
                                _withDirectives(_createElementVNode("input", {
                                  maxlength: "5000",
                                  ref: "questionInput",
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Ingresar la respuesta",
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.questionOptionText) = $event)),
                                  onKeydown: _cache[44] || (_cache[44] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addQuestionOption && _ctx.addQuestionOption(...args)), ["prevent"]), ["enter"]))
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                  [_vModelText, _ctx.questionOptionText]
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-primary",
                                  type: "button",
                                  onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.addQuestionOption && _ctx.addQuestionOption(...args)))
                                }, " Agregar ")
                              ]),
                              _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.errors.questionOptionText), 1 /* TEXT */)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.errors.questionOptions), 1 /* TEXT */),
                        _createElementVNode("ul", {
                          class: "ps-0 mb-0 list-unstyled o-sortable cursor-move list-group",
                          onDragover: _cache[49] || (_cache[49] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionOptions, (drag, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: drag.id,
                              onDragstart: ($event: any) => (_ctx.dragStart(index)),
                              onDragend: _cache[47] || (_cache[47] = ($event: any) => (_ctx.dragEnd())),
                              onDragover: _cache[48] || (_cache[48] = _withModifiers(() => {}, ["prevent"])),
                              onDrop: ($event: any) => (_ctx.dragDrop(index)),
                              draggable: "true",
                              class: _normalizeClass([
                    'p-2 ps-3 rounded-2  d-flex align-items-center justify-content-between list-group-item list-group-item-primary bg-transparent text-primary',
                  ])
                            }, [
                              _createCommentVNode(" LEFT SIDE "),
                              _createElementVNode("div", _hoisted_122, [
                                _cache[89] || (_cache[89] = _createElementVNode("div", {
                                  class: "me-2 d-flex align-items-center justify-content-center",
                                  style: {"width":"20px"}
                                }, [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary cursor-move" }, "drag_indicator")
                                ], -1 /* HOISTED */)),
                                _createElementVNode("div", _hoisted_123, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((drag.isCorrect) = $event),
                                    class: "form-check-input me-3 mt-0"
                                  }, null, 8 /* PROPS */, _hoisted_124), [
                                    [_vModelCheckbox, drag.isCorrect]
                                  ]),
                                  _createCommentVNode(" Inline edit "),
                                  (drag.isEditing)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": ($event: any) => ((drag.option) = $event),
                                          class: "form-control form-control-sm h-45 me-2",
                                          style: {"width":"710px","height":"36px"}
                                        }, null, 8 /* PROPS */, _hoisted_126), [
                                          [_vModelText, drag.option]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn btn-sm btn-success text-success bg-transparent me-1 pb-0",
                                          onClick: ($event: any) => (_ctx.saveOption(index)),
                                          title: "Guardar"
                                        }, [...(_cache[87] || (_cache[87] = [
                                          _createElementVNode("span", { class: "material-symbols-outlined fw-bold" }, "check", -1 /* HOISTED */)
                                        ]))], 8 /* PROPS */, _hoisted_127),
                                        _createElementVNode("button", {
                                          class: "btn btn-sm btn-danger text-danger bg-transparent pb-0",
                                          onClick: ($event: any) => (_ctx.cancelEdit(index)),
                                          title: "Cancelar"
                                        }, [...(_cache[88] || (_cache[88] = [
                                          _createElementVNode("span", { class: "material-symbols-outlined fw-bold" }, "close", -1 /* HOISTED */)
                                        ]))], 8 /* PROPS */, _hoisted_128)
                                      ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createCommentVNode(" Normal view "),
                                        _createElementVNode("span", _hoisted_129, _toDisplayString(drag.option), 1 /* TEXT */)
                                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                ])
                              ]),
                              _createCommentVNode(" RIGHT SIDE: Buttons "),
                              (!drag.isEditing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["btn btn-sm btn-default", {
                        'text-success': drag.multimediaTypeId != null,
                        'text-primary': drag.multimediaTypeId == null,
                      }]),
                                      onClick: ($event: any) => (_ctx.editFile(index)),
                                      title: "Agregar multimedia"
                                    }, [...(_cache[90] || (_cache[90] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, "music_note_add", -1 /* HOISTED */)
                                    ]))], 10 /* CLASS, PROPS */, _hoisted_131),
                                    (
                        drag.id == 0 ||
                        _ctx.question?.answerType == _ctx.ANSWER_TYPES.SELECCION_MULTIPLE
                      )
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-sm btn-default text-primary",
                                          title: 
                        _ctx.question?.answerType == _ctx.ANSWER_TYPES.SELECCION_MULTIPLE
                          ? 'No disponible para respuesta múltiple'
                          : 'Guardar los cambios para poder agregar la acción'
                      ,
                                          style: {"cursor":"not-allowed"},
                                          onClick: _cache[46] || (_cache[46] = _withModifiers(() => {}, ["prevent"]))
                                        }, [...(_cache[91] || (_cache[91] = [
                                          _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, " asterisk ", -1 /* HOISTED */)
                                        ]))], 8 /* PROPS */, _hoisted_132))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: _normalizeClass(
                        drag.isQuestion != null
                          ? 'btn btn-sm btn-default text-success'
                          : 'btn btn-sm btn-default text-primary'
                      ),
                                          onClick: ($event: any) => (_ctx.editFileQuestion(drag)),
                                          title: 
                        drag.isQuestion != null
                          ? 'Actualizar acción'
                          : 'Agregar acción'
                      
                                        }, [...(_cache[92] || (_cache[92] = [
                                          _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, " asterisk ", -1 /* HOISTED */)
                                        ]))], 10 /* CLASS, PROPS */, _hoisted_133)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-default text-primary",
                                      onClick: ($event: any) => (_ctx.editOption(index)),
                                      title: "Editar"
                                    }, [...(_cache[93] || (_cache[93] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, "edit", -1 /* HOISTED */)
                                    ]))], 8 /* PROPS */, _hoisted_134),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-default text-primary",
                                      onClick: ($event: any) => (_ctx.removeQuestionOption(index)),
                                      title: "Eliminar"
                                    }, [...(_cache[94] || (_cache[94] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined menu-icon me-0" }, "delete", -1 /* HOISTED */)
                                    ]))], 8 /* PROPS */, _hoisted_135)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_121))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 32 /* NEED_HYDRATION */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _createVNode(_component_RouterLink, {
                      to: 
                  _ctx.route.path.split('/')[1] != 'repository'
                    ? `/play/config/${_ctx.idPlay}`
                    : '/repository'
                
                    }, {
                      default: _withCtx(() => _cache[96] || (_cache[96] = [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                        }, " Cancelar ", -1 /* HOISTED */)
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"]),
                    _createElementVNode("button", {
                      class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                      type: "submit",
                      disabled: _ctx.isLoading
                    }, [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_140, _toDisplayString(_ctx.question.id == 0 ? "Crear Acción" : "Actualizar Acción"), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_141))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_142, "Procesando..."))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_139)
                  ])
                ])
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_143, [
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          _cache[98] || (_cache[98] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlFileUploadLabel"
            }, " Jugada - Archivo "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_146, [
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("div", _hoisted_148, [
                (_ctx.questionOptionEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                      _cache[97] || (_cache[97] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo de Multimedia", -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.questionOptionEdit.multimediaTypeId) = $event)),
                        onChange: _cache[53] || (_cache[53] = _withModifiers(($event: any) => (
                    _ctx.setMultimediaTypeQuestionOptionContent(
                      _ctx.questionOptionEdit.multimediaTypeId
                    )
                  ), ["prevent"])),
                        class: "form-select form-control h-45",
                        "aria-label": "Default select example"
                      }, [
                        _createElementVNode("option", _hoisted_150, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                        _createElementVNode("option", {
                          value: _ctx.MULTIMEDIA_TYPES.IMAGE
                        }, _toDisplayString(_ctx.multimediaOptions[_ctx.MULTIMEDIA_TYPES.IMAGE - 1].label), 9 /* TEXT, PROPS */, _hoisted_151),
                        _createElementVNode("option", {
                          value: _ctx.MULTIMEDIA_TYPES.AUDIO
                        }, _toDisplayString(_ctx.multimediaOptions[_ctx.MULTIMEDIA_TYPES.AUDIO - 1].label), 9 /* TEXT, PROPS */, _hoisted_152)
                      ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelSelect, _ctx.questionOptionEdit.multimediaTypeId]
                      ]),
                      _createElementVNode("div", _hoisted_153, _toDisplayString(_ctx.errors.multimediaTypeId), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_154, [
              (!_ctx.questionOptionEdit?.urlMultimediaBlob)
                ? (_openBlock(), _createBlock(_component_FilePond, {
                    key: 0,
                    ref: "filePondRefAction",
                    name: "multimedia",
                    maxFileSize: '2MB',
                    "accepted-file-types": _ctx.supportedFormatsModal,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormatsModal.join(
                ', '
              )}`,
                    credits: "",
                    onRemovefile: _ctx.handleRemoveFileModal
                  }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onRemovefile"]))
                : _createCommentVNode("v-if", true),
              (_ctx.questionOptionEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                    (
                  _ctx.questionOptionEdit.multimediaTypeId ==
                    _ctx.MULTIMEDIA_TYPES.IMAGE &&
                  _ctx.questionOptionEdit?.urlMultimediaBlob
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                          _createElementVNode("img", {
                            src: _ctx.questionOptionEdit?.urlMultimediaBlob,
                            alt: "Multimedia",
                            class: "img-fluid mb-2 d-block",
                            style: {"width":"50%"}
                          }, null, 8 /* PROPS */, _hoisted_157)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (
                  _ctx.questionOptionEdit.multimediaTypeId ==
                    _ctx.MULTIMEDIA_TYPES.AUDIO &&
                  _ctx.questionOptionEdit?.urlMultimediaBlob
                )
                      ? (_openBlock(), _createElementBlock("audio", {
                          key: 1,
                          src: _ctx.questionOptionEdit?.urlMultimediaBlob,
                          controls: "",
                          style: {"margin-top":"1rem"}
                        }, null, 8 /* PROPS */, _hoisted_158))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_159, [
                (_ctx.questionOptionEdit?.urlMultimediaBlob)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[54] || (_cache[54] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeMultimediaFileModal && _ctx.removeMultimediaFileModal(...args)), ["prevent"])),
                      class: "btn btn-danger"
                    }, " Eliminar multimedia "))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.closeModalFile && _ctx.closeModalFile(...args)))
            }, " Guardar ")
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_161, [
      _createElementVNode("div", _hoisted_162, [
        _createElementVNode("div", _hoisted_163, [
          _createElementVNode("div", _hoisted_164, [
            (_ctx.questionOptionFreeEdit)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_165, " Respuesta - " + _toDisplayString(_ctx.questionOptionFreeEdit.option), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _cache[99] || (_cache[99] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1 /* HOISTED */))
          ]),
          _createElementVNode("div", _hoisted_166, [
            _createElementVNode("div", _hoisted_167, [
              _createElementVNode("div", _hoisted_168, [
                (_ctx.questionOptionFreeEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                      _cache[100] || (_cache[100] = _createElementVNode("label", { class: "label text-secondary strong" }, "Pregunta", -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.questionOptionFreeEdit.nextQuestionId) = $event)),
                        class: "form-select form-control h-45",
                        "aria-label": "Default select example"
                      }, [
                        _createElementVNode("option", _hoisted_170, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsQuestion, (item, i) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.id,
                            key: i
                          }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_171))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, _ctx.questionOptionFreeEdit.nextQuestionId]
                      ]),
                      _createElementVNode("div", _hoisted_172, _toDisplayString(_ctx.errors.nextQuestionId), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_173, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.closeModalFileQuestion && _ctx.closeModalFileQuestion(...args)))
            }, " Guardar ")
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}